import { useState } from 'react';
import { Button } from 'shared-components';
import { UploadZone } from '../uploader/upload-zone';
import { addUploads } from '../uploader/uploader-slice';
import { close } from '../modal/modalSlice';
import { ButtonTier } from 'shared-components';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { Upload } from '../uploader/uploader.types';
import { useGetAlbumRawImageUploadUrlMutation } from './albums.api';
import styles from './image-upload-modal.module.css';
import { selectTokenPayload } from '../login/authSlice';

export const ImageUploadModal = ({ albumId }: { albumId: string }) => {
  const dispatch = useAppDispatch();
  const tokenData = useAppSelector(selectTokenPayload);
  const [uploadList, setUploadList] = useState<
    Pick<Upload, 'file' | 'destination'>[]
  >([]);
  const [getUrl] = useGetAlbumRawImageUploadUrlMutation();
  return (
    <div className={styles.imageUploadModal}>
      <UploadZone
        className={styles.uploadZone}
        onFileChange={(files) => {
          const newList = files.map((file) => ({
            file,
            destination: ``,
          }));
          setUploadList(newList);
        }}
      />
      <Button
        bigger={true}
        tier={ButtonTier.Secondary}
        onClick={() => {
          dispatch(close());
        }}
      >
        Cancel
      </Button>
      {uploadList.length > 0 && (
        <Button
          onClick={async () => {
            //get upload url and update uploadList
            await Promise.all(
              uploadList.map(async (upload) => {
                const urlResponse = (await getUrl({
                  albumId,
                  filename: upload.file.name,
                })) as {
                  data: { url: string };
                };
                dispatch(
                  addUploads([
                    {
                      ...upload,
                      destination: urlResponse.data.url,
                      onComplete: [
                        {
                          action: 'requestRawImageProcess',
                          args: [
                            albumId,
                            upload.file.name,
                            tokenData?.accountId.toString() || '',
                          ],
                        },
                      ],
                    },
                  ])
                );
              })
            );
            dispatch(close());
          }}
        >
          Upload
        </Button>
      )}
    </div>
  );
};
